import type { PaletteOptions } from '@mui/material';
const defaultMUiFontsize = 16;
// we need this is we need to fix the rem size of the MUI font size
// the default size in ts-ui is 14px and in MUI is 16px
export const defaultMUiFontsizePlusTwo = defaultMUiFontsize + 2;

const tsGoColor = {
	// Base
	white: 'hsl(0, 0%, 100%)',
	black: 'hsl(204, 25%, 8%)',
	// Grey
	gray: 'hsl(198, 20%, 67%)',
	grayLight: (opacity = 1) => `hsla(198, 20%, 83%, ${opacity})`,
	grayDark: 'hsl(198, 20%, 59%)',
	grayDarker: 'hsl(198, 20%, 49%)',
	grayLightest: 'hsl(200, 21%, 92%)',
	// Pink
	pinkLightest: 'hsl(325, 46%, 89%)',
	pinkLighter: 'hsl(325, 48%, 78%)',
	pinkLight: 'hsl(325, 48%, 57%)',
	pink: 'hsl(325, 98%, 33%)',
	pinkDark: 'hsl(327, 99%, 26%)',
	pinkDarker: 'hsl(329, 100%, 21%)',
	// Blue
	blue: 'hsl(199, 100%, 50%)',
	blueDark: 'hsl(201, 100%, 40%)',
	// Green
	greenDark: 'hsl(101, 87%, 33%)',
	greenLight: 'hsl(99, 61%, 63%)',
	greenLighter: 'hsl(99, 60%, 81%)',
	green: 'hsl(99, 85%, 42%)',
	// Red
	red: 'hsl(0, 100%, 37%)',
	lightRed: 'hsl(0, 100%, 37%)',
	// Orange
	orange: 'hsl(33, 100%, 40%)', // original is 50% on lightness
	// Slate
	slateLighter: 'hsl(199, 20%, 31%)',
	slateDarker: 'hsl(197, 20%, 7%)',
	// Yellow
	yellowLightest: 'hsl(44, 95%, 92%)',
	yellow: 'rgb(255, 145, 0)',
	yellowDarker: 'hsl(34, 100%, 49%)',
};

const tsGoBorder = {
	noBorder: 'none',
	dottedBorder: '1px dotted rgba(127,115,72,.5)',
};

type CustomPalette = PaletteOptions & { tsGoColor: typeof tsGoColor } & { tsGoBorder: typeof tsGoBorder };

export const goPalette: CustomPalette = {
	// Used by `getContrastText()` to maximize the contrast between
	// the background and the text.
	// increased  to 2.5 as not all ts-ui colors follow accessibility ratio
	contrastThreshold: 2.5,
	success: {
		main: tsGoColor.green,
	},
	error: {
		main: tsGoColor.red,
	},
	warning: {
		main: tsGoColor.orange,
	},
	info: {
		main: tsGoColor.blue,
	},
	tsGoColor,
	tsGoBorder,

	secondary: {
		dark: 'rgb(230, 236, 239)',
		light: 'rgb(255, 255, 255)',
		main: 'rgb(255, 255, 255)',
	},
} as const;

export const tsGoTypography = {
	pxToRem(px: number, baseFontSize = defaultMUiFontsize) {
		return `${px / baseFontSize}rem`;
	},

	tsFontSize: {
		verySmall: 10,
		small: 11,
		mini: 12,
		default: 14,
		medium: 16,
		big: 18,
		xbig: 24,
		icon: 22, // default icon font size
	},
	tsFontWeight: {
		default: 400,
		semiBold: 600,
		bolder: 500,
		bold: 700,
		boldest: 900,
		lighter: 300,
	},
} as const;

const tsUnit = 20;

export const tsGoUnit = {
	tsUnitQuarter: `${tsUnit / 4}px`,
	tsUnitHalf: `${tsUnit / 2}px`,
	tsUnit: `${tsUnit}px`,
	tsUnitOneAndHalf: `${tsUnit * 1.5}px`,
	tsUnitDouble: `${tsUnit * 2}px`,
	tsUnitTriple: `${tsUnit * 3}px`,
	tsUnitWidthAside: '320px',
} as const;
